export default {
  methods: {
    mxCurrencyFormatter(value, digits = 2, suffix = 'euro') {
      if (value) {
        // const v = value.toLocaleString(undefined, { maximumFractionDigits: digits });
        // const finalFormated = String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // return `${finalFormated} euro`;
        // .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        const fixedNumber = Number.parseFloat(value).toFixed(digits);
        const string = String(fixedNumber.toString().replace('.', ','));
        const parts = string.split(',');

        const firstPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        return `${firstPart},${parts[1]} ${suffix}`;

        // return `${String(fixedNumber.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))} ${suffix}`;
      }
      if (value === 0) {
        return `0,00 ${suffix}`;
      }
      return null;
    },
  },
};
